export default __webpack_public_path__ + "static/media/orca-long.eac68181.png";